import React from "react";

const Empty = () => {
	return <></>;
};

export default Empty;
